<!--
 * @Author: hanhuixian hanhuixian@lxrental.com
 * @Date: 2022-06-26 17:00:47
 * @FilePath: \rental-ir\src\layout\components\header-bar\HeaderBar.vue
 * @Description: 页面Html框架（底部导航栏）
-->
<template>
  <section class="uk-section uk-section-small uk-background-primary footerbar">
    <div class="uk-container uk-container-large uk-text-middle uk-text-center">
      <div class="uk-panel uk-panel-box uk-text-break">
        <span
          >Copyright © 2013 - 2025 凌雄技术（深圳）有限公司. All Rights
          Reserved</span
        >
        <span class="uk-margin-left uk-text-nowrap">
          <a
            href="http://beian.miit.gov.cn/publish/query/indexFirst.action"
            target="_blank"
            >粤ICP备15099642号</a
          >
          <a
            href="http://beian.miit.gov.cn/publish/query/indexFirst.action"
            target="_blank"
          >
            <img
              class="uk-margin-left"
              src="/ICBC.png"
              alt="工商网监"
              width="18"
              height="25"
            />
          </a>
        </span>
      </div>
    </div>
  </section>
</template>

<style lang="less" scoped>
  .footerbar {
    font-size: 13px;
    color: #fff;
    a {
      color: #fff;
    }
  }
</style>
